const API_URL = process.env.REACT_APP_API_URL || "https://portalapi.jumigstore.com";

export default API_URL;
